import { memo } from 'react';
import { CONSTANTS } from '../Helpers/Configuration';
import { spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { makeStyles } from '@ellucian/react-design-system/core';
import Question from './Question';
import ConditionalLogicCheck, { isConditionallyRequiredContext } from './ConditionalLogicCheck';
const useStyles = makeStyles({
    name: 'QuestionGroups'
})(theme => ({
    root: {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridGap: spacing40,
        minWidth: 0,
        width: '100%',
    },
    groupRoot: {
        display: 'grid',
        gridTemplateRows: '1fr',
        gridColumnGap: spacing40,
        gridTemplateColumns: 'repeat(6, 1fr)',
        minWidth: 0,
        width: '100%',
        '& > *': {
            minWidth: 0,
        },
        [theme.breakpoints.down('md')]: {
            gridTemplateColumns: '1fr',
            gridRowGap: spacing40,
        },
    },
    questionCount1: {
        gridColumn: 'span 3',
        minWidth: 0,
        [theme.breakpoints.down('md')]: {
            gridColumn: 'span 1',
        },
    },
    questionCount2: {
        gridColumn: 'span 3',
        minWidth: 0,
        [theme.breakpoints.down('md')]: {
            gridColumn: 'span 1',
        },
    },
    questionCount3: {
        gridColumn: 'span 2',
        minWidth: 0,
        [theme.breakpoints.down('md')]: {
            gridColumn: 'span 1',
        },
    },
    questionExpanded: {
        gridColumn: 'span 6',
        minWidth: 0,
    },
}));

const QuestionGroups = props => {
    const {
        groups = [],
        prefix,
        repeatingSection = false,
        sectionId,
        pageId
    } = props;
    const { classes } = useStyles();
    return (
        <div className={classes.root}>
            {groups.map((group, groupIndex) => {
                const questionClass = classes[`questionCount${group.questions.length.toString()}`];
                return (
                    <div key={groupIndex} className={classes.groupRoot}>
                        {group.questions.map((q, questionIdx) => {
                            return (
                                <ConditionalLogicCheck
                                    key={questionIdx}
                                    conditions={q.conditions}
                                    prefix={prefix}
                                    content={q}
                                    contentType={CONSTANTS.appTemplateControlTypes.question}
                                    repeatingSection={repeatingSection}
                                    sectionId={sectionId}
                                >
                                    <div className={q.columnWidth === CONSTANTS.columnWidthOptions.extended ? classes.questionExpanded : questionClass}>
                                        <isConditionallyRequiredContext.Consumer>
                                            {isConditionallyRequired =>
                                                <Question
                                                    prefix={prefix}
                                                    question={q}
                                                    isConditionallyRequired={isConditionallyRequired}
                                                    pageId={pageId}
                                                />
                                            }
                                        </isConditionallyRequiredContext.Consumer>
                                    </div>
                                </ConditionalLogicCheck>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};
export default memo(QuestionGroups);